import { ContentEntity, EventUnion, MentionEntityTypeEnum, UserType } from '@/types/schema';

import { MentionsData, MentionsProps } from '../../types';

export interface MentionGroupListProps extends MentionsProps {
  setView?: (viewType: MentionEntityTypeEnum) => void;
  setInitialMentions: React.Dispatch<React.SetStateAction<MentionsData | undefined>>;
}

export enum ItemTypeEnum {
  Header = 'HEADER',
}

export interface HeadingItemType {
  type: ItemTypeEnum.Header;
  item: {
    heading: string;
    id: MentionEntityTypeEnum;
  };
}

export interface UserItemType {
  type: MentionEntityTypeEnum.User;
  item: UserType;
  index: number;
}

export interface EventItemType {
  type: MentionEntityTypeEnum.Event;
  item: EventUnion;
  index: number;
}

export interface ContentItemType {
  type: MentionEntityTypeEnum.Content;
  item: ContentEntity;
  index: number;
}

export type RenderItemType = EventItemType | HeadingItemType | UserItemType | ContentItemType;
